import { AboutYouModel, AboutYourBusinessFinancialRequired, BusinessEntityModel } from '../model';

export const SINGPASS_ABOUT_YOU_MAP_FIELD: Partial<Record<keyof AboutYouModel, boolean>> = {
  name: true,
  nricNumber: true,
  dateOfBirthOnly: true,
  gender: true,
  // addresses: true,
  nationalityId: true,
  // contactNumber: true,
  // email: true,
  // maritalStatus: true,
  placeOfBirthCountryId: true,
  residentialStatus: true,
  address: true,
  // contactAreaCode: true,
  // cpfAttachments: true,
  // noaAttachments: true,
} as const;

export const ABOUT_YOU_DISABLED_FIELD: Partial<Record<keyof AboutYouModel, boolean>> = {
  name: true,
  nricNumber: true,
} as const;

export const SINGPASS_BUSINESS_ENTITY_MAP_FIELD: Partial<Record<keyof BusinessEntityModel, boolean>> = {
  registeredAddress: true,
  address: true,
  // businessClassification: true,
} as const;

export const DISABLED_FINANCIAL_REQUIRED_MAP_FIELD: Partial<Record<keyof AboutYourBusinessFinancialRequired, boolean>> = {
  product: true,
  amountRequired: true,
  tenure: true,
} as const;
